import { type DateTime, getDateTimeDifference, todayDateTime } from '@rentguru/commons-utils';
import isNil from 'lodash/isNil';

import { SECONDS_BEFORE_RETRYING_A_FAILED_FETCH } from '../constants';

export const isTooEarlyToRetryFailedFetch = (lastFailure?: DateTime | null): boolean =>
  !isNil(lastFailure) &&
  getDateTimeDifference({ start: lastFailure, end: todayDateTime() }, 'seconds') <
    SECONDS_BEFORE_RETRYING_A_FAILED_FETCH;
